import { initializeApp } from 'firebase/app';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from "firebase/analytics";
import { getStorage } from 'firebase/storage';

export const firebaseConfig = {
  apiKey: "AIzaSyAi6pW0LemLD2dOP0LH5asGwTRLfGP1Q2g",
  authDomain: "musegame-dc6b8.firebaseapp.com",
  databaseURL: "https://musegame-dc6b8-default-rtdb.firebaseio.com",
  projectId: "musegame-dc6b8",
  storageBucket: "musegame-dc6b8.firebasestorage.app",
  messagingSenderId: "365725048767",
  appId: "1:365725048767:web:d9787a6e9566e02bda0b0a",
  measurementId: "G-WBSR6956QX"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const dbMarketing = getFirestore(app, "marketing");
const analytics = getAnalytics(app);
const storage = getStorage(app);

async function ensureAnonymousAuth() {
  if (!auth.currentUser) {
    try {
      await signInAnonymously(auth);
      console.log("Signed in anonymously");
    } catch (error) {
      console.error("Error signing in anonymously:", error);
    }
  }
}

export { auth, db, dbMarketing, analytics, storage, ensureAnonymousAuth };
